module.exports = __webpack_public_path__ + "img/edge_restauration_vin.c69bd274.svg";